export default __webpack_public_path__ + "static/media/QR.025b57b9.jpg";